import { Box } from "@mui/material";
import styled from "styled-components";

export const ScheduleCardTopContainer = styled(Box as any)`
  width: 100%;
  padding-bottom: 4px;
  display: flex;

  > div {
    min-height: 56px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  #buttonsRight {
    display: flex;
  }
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  gap: 8px;

  @media (max-width: 600px) {
    flex-wrap: wrap;
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-left: 0px !important;
  margin-left: -16px;
  flex: 1 1 0;
  min-width: 0;

  > div:last-child {
    min-width: 0;
  }

  > div:first-child {
    padding-top: 0;
    padding-bottom: 0;
  }

  @media (max-width: 600px) {
    flex-basis: 100%;
  }
`;

export const RightContainer = styled.div`
  width: auto;
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  flex-shrink: 0;
  margin-right: 0 !important;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  gap: 2px;
`;
